<div class="child sub-view">
    <div class="content solo">
        <section class="child">
            <div c-toggle="copyWorkflow.show" c-toggle-options="{type: 'fade'}">
                <div class="warning" ng-bind-html="'contractflow.copyNotAllowed'|translate"></div>
            </div>
        </section>
    </div>
</div>